/* [수정된 파일: WormUp-main/src/page/solopage/solopage.js] */

import React, { useState } from "react"; // [수정] useState 임포트
import { Input } from "../../components/Input/Input.js";
import wormup from "../../components/image/wormup.svg";

import "../../style/style.css";

import { StartButton } from "../../components/Button/Button.js";

function SoloPage() {
  const text1 = "<  Solo Play  >";

  // [추가] 닉네임 입력을 관리할 state
  const [nickname, setNickname] = useState("");

  // [추가] Input 값이 변경될 때마다 state를 업데이트하는 함수
  const handleNicknameChange = (e) => {
    setNickname(e.target.value);
  };

  // [추가] 시작 버튼 클릭 시 닉네임을 저장하고 게임 페이지로 이동하는 함수
  const handleStartGame = () => {
    // 닉네임이 비어있으면 "Player"를 기본값으로 사용
    localStorage.setItem("playerName", nickname || "Player");
    // 3단계에서 생성될 game.html로 페이지 이동
    window.location.href = "./game.html";
  };

  return (
    <div className="bg">
      <img src={wormup} alt="내 로고" />

      <div>
        <p className="text1">{text1}</p>
        <p className="text2">내 정보를 입력하고 러닝을 시작하세요. <br />목표 설정이 어려울 경우, 웜업이 목표를 추천해줘요 </p>
      </div>

      {/* [수정] Input에 value와 onChange를 연결 */}
      <Input
        type="text"
        placeholder="닉네임을 입력하세요"
        value={nickname}
        onChange={handleNicknameChange}
      />

      {/* [수정] StartButton에 onClick 핸들러를 연결 */}
      <StartButton onClick={handleStartGame} />
    </div>
  );
}

export default SoloPage;